import { z } from "zod";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

const searchSchema = z.object({
  wave: z.enum(["T0", "T1", "T2"]).catch("T0"),
});

export const Route = createFileRoute("/(content)/study/done")({
  component: StudyDoneComponent,
  validateSearch: searchSchema,
  head: () => ({ meta: [{ title: "Thank you - HAMD" }] }),
  beforeLoad: () => ({
    title: "study.done.title",
    navbar: { showTitle: true, onBack: false },
  }),
});

const DONE_TITLE_KEYS: Record<"T0" | "T1" | "T2", string> = {
  T0: "study.done.t0.title",
  T1: "study.done.t1.title",
  T2: "study.done.t2.title",
};

const DONE_BODY_KEYS: Record<"T0" | "T1" | "T2", string> = {
  T0: "study.done.t0.body",
  T1: "study.done.t1.body",
  T2: "study.done.t2.body",
};

function StudyDoneComponent() {
  const navigate = useNavigate();
  const { wave } = Route.useSearch();

  const titleKey = DONE_TITLE_KEYS[wave];
  const bodyKey = DONE_BODY_KEYS[wave];

  return (
    <ExerciseLayout
      actions={
        <Button
          className="w-full"
          onClick={() => navigate({ to: "/adults/exercises" })}
        >
          <FormattedMessage id="study.done.returnHome" />
        </Button>
      }
    >
      <div className="space-y-6 pt-10 text-center">
        <h2 className="text-h2 text-primary">
          <FormattedMessage id={titleKey} />
        </h2>
        <p className="text-body text-dark-gray">
          <FormattedMessage id={bodyKey} />
        </p>
      </div>
    </ExerciseLayout>
  );
}
